export const CONSTANTS: any = {
    arcTooltipClassname: "gauge-component-arc-tooltip",
    tickLineClassname: "tick-line",
    tickValueClassname: "tick-value",
    valueLabelClassname: "value-text",
    debugLogs: false,
    debugTicksRadius: false,
    debugSingleGauge: false,
    rangeBetweenCenteredTickValueLabel: [0.35, 0.65]
} 
export default CONSTANTS;